import {initCore} from 'src/lib/init.js'
import Vue from 'vue'
import AbcFileUploader from "@/abc/AbcFileUploader.vue"

initCore()
new Vue({
    el: '#vue-container',
    components: {
        AbcFileUploader,
    },
})
